import React, { Component } from "react";
import * as k from "./constants";
import MainPage from "./MainPage";
import firebase from "./firebase/firebase";
import { useAsync } from "react-async";
import {
  searchFriends,
  getMessages,
  isfollowing,
  countfollow,
} from "./dao/post";

class SearchFriends extends Component {
  constructor(props) {
    super(props);
    this.state = {
      txtSearch: "",
      showFriend: false,
      messages: [],
      displayPost: "none",
      loading: true,
      username: "",
      selFriend: "",
      follower: 0,
      following: 0,
      isfollow: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.findFriends = this.findFriends.bind(this);
    this.showSearchScreen = this.showSearchScreen.bind(this);
  }

  handleState = (name, val) => {
    this.setState({
      [name]: val,
    });
  };

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  findFriends() {
    if (this.state.txtSearch.trim().length > 0) {
      //this.getFriends(this.state.txtSearch);
      let searchTxt = this.state.txtSearch;
      let fuser = this.props.appProps.state.userid;
      searchFriends(searchTxt, fuser, this.props.mainCtrlProps);
    } else {
      console.log("empty search");
      this.props.mainCtrlProps.handleState("search", []);
    }
  }

  showSearchScreen() {
    this.setState({
      showFriend: false,
    });
  }

  showFriendPage(uid, fullname) {
    console.log("clicked friends page router", uid);
    //this.getMessages(uid);
    this.setState({
      selFriend: uid,
    });
    let cuser = this.props.appProps.state.userid;
    isfollowing(cuser, uid).then((doc) => {
      console.log("friend following ", doc.data());
      if (doc.data() && doc.data().following) {
        this.setState({ isfollow: true });
      } else {
        this.setState({ isfollow: false });
      }
    });
    countfollow(uid, "following", (res) => {
      console.log("total following", res);
      this.setState({
        following: res.total,
      });
    });
    countfollow(uid, "follower", (res) => {
      console.log("total follower", res);
      this.setState({
        follower: res.total,
      });
    });
    getMessages(uid, this);
    this.setState({
      showFriend: true,
      username: fullname,
    });
  }

  following(cuser, fuser, isfollow) {
    console.log("add friend", cuser, fuser);

    const dt = new firebase.firestore.Timestamp.fromDate(new Date());
    const fs = firebase.firestore();
    const user = fs.collection("users").doc(cuser);
    const following = user.collection("following").doc(fuser);
    if (!isfollow) {
      following
        .set({ following: true, datefollow: dt })
        .then(() => {
          console.log("firend added", fuser);
          this.setState({
            isfollow: true,
          });
          const user = fs.collection("users").doc(fuser);
          const follower = user.collection("follower").doc(cuser);
          follower.set({ follower: true, datefollow: dt }).then(() => {
            console.log("add firend follower", fuser);
          });
        })
        .catch((error) => {
          console.log("error on following", error);
        });
    } else {
      following
        .delete()
        .then(() => {
          console.log("successfully unfollowing ");
          this.setState({
            isfollow: false,
          });
          const user = fs.collection("users").doc(fuser);
          const follower = user.collection("follower").doc(cuser);
          follower.delete().then(() => {
            console.log("remove firend follower", fuser);
          });
        })
        .catch((error) => {
          console.log("error on unfollowing", error);
        });
    }
  }

  render() {
    let search = this.props.mainCtrlProps.state.search;
    let cuser = this.props.appProps.state.userid;
    let fuser = this.state.selFriend;
    let isfollow = this.state.isfollow;
    console.log("friendfollowing ", isfollow);

    if (this.state.showFriend) {
      // shows friends posts/messages
      return (
        <div>
          <div style={{ paddingLeft: "2vh", paddingRight: "2vh" }}>
            <div className="row ">
              <div class="col d-flex justify-content-start">
                <label
                  className="btn btn-outline-none text-dark close"
                  aria-label="Close"
                  onClick={this.showSearchScreen}
                >
                  <h3>
                    <i class="fa fa-arrow-left"></i>
                  </h3>
                </label>
              </div>
              <div class="col d-flex justify-content-end">
                <label
                  className="btn btn-outline-none text-dark close"
                  aria-label="Close"
                  onClick={() => this.following(cuser, fuser, isfollow)}
                >
                  <h3>{isfollow ? "-follow" : "+follow"}</h3>
                </label>
              </div>
            </div>
          </div>
          {/* calls main page with the props of the searched user */}
          <MainPage appProps={this} mainCtrlProps={this} />
        </div>
      );
    }

    return (
      // shows search screen and search list
      <div
        className="container-fluid"
        // style={{ paddingTop: "2vh" }}
      >
        <div className="row">
          {/* <div class="col-3"></div> */}
          <div class="col input-group mb-3 ">
            <input
              type="text"
              placeholder="find friends"
              className="form-control shadow-none"
              name="txtSearch"
              value={this.state.txtSearch}
              onChange={this.handleChange}
            />
            <div class="input-group-append">
              <button
                className="btn btn-secondary shadow-none"
                // onClick={this.findFriends}>
                onClick={this.findFriends}
              >
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        {search.length > 0 ? (
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Full Name</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {search.map((friend) => (
                <tr>
                  <td>
                    <div
                      className="pointer"
                      //type="button"
                      //class="btn btn-outline-none text-dark"
                      onClick={() =>
                        this.showFriendPage(friend.userid, friend.FullName)
                      }
                    >
                      <p>{friend.FullName}</p>
                    </div>
                  </td>
                  <td className="text-right">
                    {
                      // <button
                      //   type="button"
                      //   class="btn btn-outline-none text-dark"
                      //   onClick={() => this.following(cuser, fuser, isfollow)}
                      // >
                      //   {isfollow ? "-follow" : "+follow"}
                      // </button>
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default SearchFriends;
